//Please add the language resource
const cscDashboard = {
  msg:{
  }
};
export default cscDashboard



// WEBPACK FOOTER //
// ./src/page/report/cscDashboard/lang/cscDashboard.en.js